import { yupResolver } from '@hookform/resolvers/yup';
import { Grid, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { IExcelImportTemplate, saveOrUpdateTemplate } from 'wisestep-api';
import { ArrowButton, ControlledTextInput, WsButton, WsDialog } from 'wisestep-base';
import { object, string } from 'yup';

import { failed, success } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';

import UploadExcelSpreadSheetsColumns from './UploadExcelSpreadSheetsColumns';
export interface CreateExcelTemplateProps {
  openDialog: boolean;
  closeDialog(): void;
  variant: 'new' | 'edit' | 'clone';
  onEditOrCloneTemplate?: IExcelImportTemplate;
  candidatesData?: Map<any, any>;
  getLatestData: () => void;
  fileId: string;
}

const validationSchema = object().shape({
  name: string().required('Template Name is required'),
});

const CreateExcelTemplate = ({
  openDialog,
  closeDialog,
  onEditOrCloneTemplate,
  variant,
  candidatesData,
  getLatestData,
  fileId,
}: CreateExcelTemplateProps) => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [open, setOpen] = useState<boolean>(false);

  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: {
      name: onEditOrCloneTemplate?.name ?? '',
      fieldMappings: onEditOrCloneTemplate?.columnMapping ?? [],
    },
  };
  const methods = useForm(formOptions);

  const onSubmit = async () => {
    const columnsData = methods.getValues('fieldMappings').map((data) => (data ? data : ''));
    const id = variant === 'clone' ? '' : onEditOrCloneTemplate?.id;
    const excelTemplate: IExcelImportTemplate = {
      columnMapping: columnsData,
      name: methods.getValues('name'),
      id: id,
      isMapping: true,
      fileId: fileId,
    };
    const response = await saveOrUpdateTemplate(excelTemplate);
    if (response.status === 200) {
      setNotification(success('Template Save'));
    } else {
      setNotification(failed('Failed to save template'));
    }
    methods.reset({});
    closeDialog();
    getLatestData();
  };

  const openModel = () => {
    const name = variant === 'clone' ? '' : methods.getValues('name');
    methods.setValue('name', name);
    const columnMapping = methods.getValues('fieldMappings').map((data) => (data ? data : ''));
    if (!columnMapping || columnMapping.filter((mapping) => mapping).length === 0) {
      setNotification({ type: 'error', message: 'Please select mappings' });
      return;
    }

    if (columnMapping.indexOf('email') === -1) {
      setNotification({ type: 'error', message: 'Please select Email' });
      return;
    }
    setOpen(!open);
  };

  return (
    <FormProvider {...methods}>
      <Dialog open={openDialog} maxWidth="lg" fullScreen scroll={'paper'}>
        {
          <>
            <Grid container spacing={2}>
              <Grid item xs={1} justifyContent="start" m={2}>
                <ArrowButton title="Go Back" onClick={() => closeDialog()}></ArrowButton>
              </Grid>
              <Grid container direction="row" justifyContent="flex-end">
                <Grid item xs={2} p={2}>
                  <WsButton fullWidth onClick={() => openModel()}>
                    Save Template
                  </WsButton>
                </Grid>
              </Grid>
            </Grid>
            <WsDialog openDialog={open} onClose={() => setOpen(false)}>
              <DialogTitle
                sx={{
                  justifyContent: 'center',
                }}
              >
                Save Template
              </DialogTitle>
              <DialogContent>
                <Grid
                  container
                  component="form"
                  onSubmit={methods.handleSubmit(onSubmit)}
                  spacing={2}
                >
                  <Grid item xs={12}>
                    <ControlledTextInput
                      fullWidth
                      name="name"
                      placeholder="Template name"
                      type="text"
                    />
                  </Grid>
                  <Grid item xs={12} display="flex" justifyContent="end">
                    <WsButton type="submit" size="large">
                      Save
                    </WsButton>
                  </Grid>
                </Grid>
              </DialogContent>
            </WsDialog>
            <UploadExcelSpreadSheetsColumns
              candidatesData={candidatesData}
              key={methods.watch('fieldMappings')}
            />
          </>
        }
      </Dialog>
    </FormProvider>
  );
};
export default CreateExcelTemplate;
